import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import FormResetPassword from '@auth/components/forms/form-reset-password/form-reset-password.vue';
import VueRecaptcha from 'vue-recaptcha';
import BpcHeaderLanguageSelector from '@shared/layouts/components/header/header-language-selector.vue';

@Component({
  name: 'bpc-reset-password',
  components: {
    'bpc-form-reset-password': FormResetPassword,
    ValidationObserver,
    'vue-recaptcha': VueRecaptcha,
    BpcHeaderLanguageSelector,
  },
})
export default class ResetPassword extends Vue {
  $refs!: {
    form: InstanceType<typeof FormResetPassword> & { resetPassword(): void };
    recaptcha: InstanceType<typeof VueRecaptcha> & { reset(): void };
  };

  get tenantAlias(): string {
    return this.$clientRouter.getTenantAlias();
  }

  sendingPassword: boolean = false;
  showAlertSuccess: boolean = false;
  showAlertDanger: boolean = false;
  alertMessage: string = '';
  defaultBackground: string = 'background-color: rgba(15, 58, 93, 0.85)';

  recaptchaVerified: boolean = false;
  recaptchaCode: string = null;

  get background() {
    return this.tenantBackground
      ? `background-image: url("${this.tenantBackground}")`
      : this.defaultBackground;
  }

  get logo() {
    return `background-image: url("${this.tenantLogo}")`;
  }

  get lang(): string {
    return this.$store.getters['auth/userLang'] || this.$i18n.locale;
  }

  get tenantBackground() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].background
    ) {
      let background = this.$store.getters['centerSettings/centerSettings'].background;
      if (typeof background === 'string') {
        background = JSON.parse(background);
      }
      return background.url;
    }
    return null;
  }
  get tenantLogo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (logo && typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }

  get withRecaptcha(): boolean {
    return !!process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  }

  get sitekey(): string {
    return process.env.VUE_APP_RECAPTCHA_SITE_KEY || '6Le_IMcZAAAAAGFibon8pJAIB809CODlqFdHRowK';
  }

  get settingsLoaded() {
    return !this.$store.getters['centerSettings/isLoading'];
  }

  get availableLanguages() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/centerSettings'].available_languages;
    }
    return null;
  }

  get selectedUserLang() {
    return this.$store.getters['auth/userLang'];
  }
  get defaultLanguage() {
    if (this.$store.getters['centerSettings/centerSettings']) {
      return this.$store.getters['centerSettings/defaultLanguage'];
    }
    return null;
  }

  async beforeMount() {
    if (!this.selectedUserLang && this.lang !== this.defaultLanguage) {
      await this.translationService.getTranslations(this.defaultLanguage);
    }
  }

  resetPassword() {
    this.sendingPassword = true;
    this.hideAlert();
    this.$refs.form.resetPassword();
  }

  showAlert(event) {
    this.sendingPassword = false;
    this.alertMessage = event.message;
    this.showAlertSuccess = event.status === 'success';
    this.showAlertDanger = event.status === 'danger';
  }

  hideAlert() {
    this.alertMessage = '';
    this.showAlertSuccess = false;
    this.showAlertDanger = false;
  }

  changeSendingPassword(event) {
    this.sendingPassword = event;
  }

  onVerify(response) {
    console.log('VERIFY', response);
    this.recaptchaCode = response;
    this.recaptchaVerified = true;
  }

  onExpired() {
    console.log('EXPIRED');
    this.recaptchaVerified = false;
    this.recaptchaCode = null;
  }

  onResetRecaptcha() {
    this.recaptchaVerified = false;
    this.recaptchaCode = null;
    this.$refs.recaptcha.reset();
  }

  get token() {
    return this.$route.query.token ? this.$route.query.token : null;
  }

  get email() {
    return this.$route.query.email ? this.$route.query.email : null;
  }
}
